import Gallery from "../blocks/gallery";

const pageTemplateDefault = {
  init() {
    console.log("PageTemplateDefault initialized");
    new Gallery(".gallery");
  },
};

export default pageTemplateDefault;
